import request from '@/api/request';
const defaultRequest = request();

export function SeachCompanyRequest (data) {
  return defaultRequest({
    url: 'tracking/SeachCompanyRequest',
    method: 'post',
    data
  });
}

export function CompanyRequest (data) {
  return defaultRequest({
    url: 'tracking/CompanyRequest',
    method: 'post',
    data
  });
}

export function GetDevicesSettingRequest (data) {
  return defaultRequest({
    url: 'tracking/GetDevicesSettingRequest',
    method: 'post',
    data
  });
}

export function GetUserLoginKeyRequest (data) {
  return defaultRequest({
    url: 'tracking/GetUserLoginKeyRequest',
    method: 'post',
    data
  });
}

export function GetUsersByVehicleRequest (data) {
  return defaultRequest({
    url: 'tracking/GetUsersByVehicleRequest',
    method: 'post',
    data
  });
}

export function GetVehiclesSettingRequest (data) {
  return defaultRequest({
    url: 'tracking/GetVehiclesSettingRequest',
    method: 'post',
    data
  });
}

export function VehiclesRequest (data) {
  return defaultRequest({
    url: 'admin/VehiclesRequest',
    method: 'post',
    data
  });
}

export function TimeRequest (data) {
  return defaultRequest({
    url: 'tracking/TimeRequest',
    method: 'post',
    data
  });
}

export function GetCompanyBillingStatusesRequest (data) {
  return defaultRequest({
    url: 'billing/GetCompanyBillingStatusesRequest',
    method: 'post',
    data
  });
}

export function VehicleStatusRequest (data) {
  return defaultRequest({
    url: 'tracking/VehicleStatusRequest',
    method: 'post',
    data
  });
}

export function VehicleDailyReport (data) {
  return defaultRequest({
    url: 'tracking/DailyReport',
    method: 'post',
    data
  });
}

export function WriteReportToGoogleSheet (data) {
  return defaultRequest({
    url: 'tracking/Report',
    method: 'post',
    data
  });
}

export function SendSMS (data) {
  return defaultRequest({
    url: 'tracking/Sms',
    method: 'post',
    data
  });
}

export function NewAvailableMessage (data) {
  return defaultRequest({
    url: 'tracking/templateSms',
    method: 'post',
    data
  });
}

export function GetHistoryMessages (Token) {
  return defaultRequest({
    url: 'tracking/Sms',
    method: 'get',
    params: { Token }
  });
}

export function GetAvailableMessage (Token) {
  return defaultRequest({
    url: 'tracking/templateSms',
    method: 'get',
    params: { Token }
  });
}

export function UpdateAvailableMessage (data) {
  return defaultRequest({
    url: 'tracking/templateSms',
    method: 'put',
    data
  });
}
export function DeleteAvailableMessage ({ Id, Token }) {
  return defaultRequest({
    url: 'tracking/templateSms',
    method: 'delete',
    params: { Id, Token }
  });
}
export function GetDailyTripReport (data) {
  return defaultRequest({
    url: 'tracking/DailyReport/trip',
    method: 'post',
    data
  });
}

export function SearchCompanyByPhone (data) {
  return defaultRequest({
    url: 'tracking/SeachCompanyByPhone',
    method: 'post',
    data
  });
}

export function UpdateCompany (data) {
  return defaultRequest({
    url: 'tracking/UpdateCompany',
    method: 'put',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/tracking.js